import { render, staticRenderFns } from "./not-active.vue?vue&type=template&id=021e355e&"
import script from "./not-active.vue?vue&type=script&lang=js&"
export * from "./not-active.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports